export default {
  en: {
    json_schema_name: "{0} JSON Schema",
  },
  es : {
    json_schema_name: "JSON Schema {0}",
  },
  ca : {
    json_schema_name: "JSON Schema {0}",
  }
};
